import { render, staticRenderFns } from "./fee-import.vue?vue&type=template&id=219b21a1&"
import script from "./fee-import.vue?vue&type=script&lang=js&"
export * from "./fee-import.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports